import React, { ReactNode, useEffect, useRef } from 'react';
import { useNotification } from 'hooks/use-notification';
import { useAuthStore } from './store/auth/useAuthStore';
// import { useNotificationStore } from './store/common/useNotificationStore';

export const NotificationMiddleware: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const accessToken = useAuthStore.getState().accessToken;
  const previousTokenRef = useRef<string | null>(null);
  const wasConnectedRef = useRef<boolean>(false);


  const { connect, disconnect } = useNotification();

  useEffect(() => {
    if (!accessToken) {
      wasConnectedRef.current = false;
      previousTokenRef.current = null;
      return;
    }
    const tokenChanged = previousTokenRef.current !== null && previousTokenRef.current !== accessToken;
    // console.log("tokenChanged in notification middleware:", "equal", accessToken === previousTokenRef.current, "othercondition", accessToken && (tokenChanged || !wasConnectedRef.current));
    if (accessToken && (tokenChanged || !wasConnectedRef.current)) {
      disconnectNotification();
      previousTokenRef.current = accessToken;
      wasConnectedRef.current = true;
      connectNotification();
    }
    return () => {
      disconnect.current?.();
    };
  }, [accessToken]);

  const connectNotification = async () => {
    await connect();
  };
  const disconnectNotification = async () => {
    await disconnect.current?.();
  };

  return <>{children}</>;
};
